import React from 'react';
import { GridToolbarContainer, GridToolbarQuickFilter } from '@mui/x-data-grid';
import StatusFilter from './StatusFilter';

const WorkOrderTableToolbar = ({ searchPlaceholder,  onStatusChange, isStatusInspectionEnabled }) => {

    return (
        <GridToolbarContainer className="work-order-toolbar-container">
            <p className="work-order-tab-title">
                Work Orders will be removed from table once printed.
            </p>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                {isStatusInspectionEnabled && (
                    <StatusFilter 
                        
                        onStatusChange={onStatusChange}
                    />
                )}
                <GridToolbarQuickFilter
                    placeholder={searchPlaceholder}
                    className="work-order-quick-filter"
                />
            </div>
        </GridToolbarContainer>
    );
};

export default WorkOrderTableToolbar;